import React, { FC, ReactNode } from 'react'
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  row: {
    '& > th, td': {
      padding: 0,
    },
    '&:last-child > th': {
      borderBottom: 'none',
    },
    '&:last-child > td': {
      borderBottom: 'none',
    },
  },
  title: {
    padding: 6,
    fontSize: 12,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    borderBottom: 'none',
  },
  name: {
    fontSize: 12,
    fontWeight: 'bold',
    width: 160,
  },
  check: {
    width: 50,
    color: theme.palette.info.main,
  },
}))

const createData = (
  name: string,
  admin: ReactNode,
  executer: ReactNode | null,
  accountant: ReactNode | null,
  viewer: ReactNode | null,
) => {
  return { name, admin, executer, accountant, viewer }
}
const check = <span className="material-icons">check</span>

const rows = [
  createData('Request Quotes', check, check, null, null),
  createData('Execute Trades', check, check, null, null),
  createData('Manage Crypto Addresses', check, null, check, null),
  createData('Manage Bank Accounts', check, null, check, null),
  createData('Request Settlements', check, null, check, null),
  createData('View past trades', check, check, check, check),
  createData('View balance activity', check, check, check, check),
  createData('View crypto addresses', check, null, check, check),
  createData('View bank account into', check, null, check, check),
  createData('Manage users', check, null, null, null),
  createData('Manage KYC status', check, check, check, check),
]

export const HelpTable: FC = () => {
  const classes = useStyles()

  return (
    <Table size="small" aria-label="a dense table">
      <TableHead>
        <TableRow>
          <TableCell className={classes.title}>{null}</TableCell>
          <TableCell className={classes.title} align="center">
            Admin
          </TableCell>
          <TableCell className={classes.title} align="center">
            Executor
          </TableCell>
          <TableCell className={classes.title} align="center">
            Accountant
          </TableCell>
          <TableCell className={classes.title} align="center">
            Viewer
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((row) => {
          return (
            <TableRow className={classes.row} key={row.name}>
              <TableCell className={classes.name} component="th" scope="row">
                {row.name}
              </TableCell>
              <TableCell className={classes.check} align="center">
                {row.admin}
              </TableCell>
              <TableCell className={classes.check} align="center">
                {row.executer}
              </TableCell>
              <TableCell className={classes.check} align="center">
                {row.accountant}
              </TableCell>
              <TableCell className={classes.check} align="center">
                {row.viewer}
              </TableCell>
            </TableRow>
          )
        })}
      </TableBody>
    </Table>
  )
}
